import { render, staticRenderFns } from "./QuestionShowB.vue?vue&type=template&id=28a001ba&scoped=true&"
import script from "./QuestionShowB.vue?vue&type=script&lang=js&"
export * from "./QuestionShowB.vue?vue&type=script&lang=js&"
import style0 from "./QuestionShowB.vue?vue&type=style&index=0&id=28a001ba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a001ba",
  null
  
)

export default component.exports